// Adapted from: https://github.com/Swizec/useDimensions

import { useState, useCallback, useLayoutEffect } from 'react';

function getDimensionObject(node) {
  const rect = node.getBoundingClientRect();

  return {
    width: rect.width,
    height: rect.height,
    top: 'x' in rect ? rect.x : rect.top,
    left: 'y' in rect ? rect.y : rect.left,
    x: 'x' in rect ? rect.x : rect.left,
    y: 'y' in rect ? rect.y : rect.top,
    right: rect.right,
    bottom: rect.bottom,
  };
}

export function useDimensions(liveMeasure = true, listeners = ['resize', 'scroll']) {
  const [dimensions, setDimensions] = useState({});
  const [node, setNode] = useState(null);

  const ref = useCallback(n => {
    setNode(n);
  }, []);

  useLayoutEffect(() => {
    if (node && process.env.NODE_ENV !== 'test') {
      const measure = () => window.requestAnimationFrame(() => setDimensions(getDimensionObject(node)));
      const animationFrameRequestId = measure();

      if (liveMeasure) {
        listeners.forEach(event => {
          window.addEventListener(event, measure);
        });

        return () => {
          listeners.forEach(event => {
            window.removeEventListener(event, measure);
          });
        };
      }

      return () => window.cancelAnimationFrame(animationFrameRequestId);
    }

    return _.noop;
  }, [node]);

  return [ref, dimensions, node];
}
